import React, { useState, useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import Routes from '_/routes';
import { GlobalStyle } from '@plataforma/components';
import { GlobalStyleLocal } from '_/styles';
import { EnvironmentsService } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import Cookies from 'js-cookie';
import { SUPER_USER_ACCESS_COOKIE } from '@plataforma/utils';
import { store } from './store';
import { RemoteConfigProvider } from './context/RemoteConfigContext';

import { Main } from './AppStyles';

const App = () => {
  const [environmentsReturned, setEnvironmentsReturned] = useState(false);

  useEffect(() => {
    const getEnvironments = async () => {
      const urlEnvironment = JSON.parse(sessionStorage.getItem('environments'));

      if (!urlEnvironment) {
        try {
          const environmentAPI = new EnvironmentsService();
          const superUser = Cookies.getJSON(SUPER_USER_ACCESS_COOKIE) || null;

          if (superUser !== null) {
            await environmentAPI.getSuperUserEnvironments(
              superUser.token.access_token
            );
          } else {
            await environmentAPI.getEnvironments();
          }

          setEnvironmentsReturned(true);
        } catch (error) {
          setEnvironmentsReturned(true);
        }
      } else {
        setEnvironmentsReturned(true);
      }
    };
    getEnvironments();
  }, []);

  return (
    <RemoteConfigProvider>
      <ReduxProvider store={store}>
        <Main>
          <GlobalStyle />
          <GlobalStyleLocal />
          {environmentsReturned && <Routes />}
        </Main>
      </ReduxProvider>
    </RemoteConfigProvider>
  );
};

export default App;
